import { WextractorSource } from '@tm/types/review'
import {
  capterra as CapterraIcon,
  facebook as FacebookIcon,
  g2 as G2Icon,
  google as GoogleIcon,
  googleplay as GooglePlayIcon,
  tripadvisor as TripadvisorIcon,
  yelp as YelpIcon,
} from '../sources'

export interface ImportSource {
  sourceProviders: string[]
  source: string
  icon: (props: { color?: string }) => JSX.Element
  url: string
  hasSourceSearch?: boolean
  isLanguageSpecific?: boolean
}

export const sourceServices = [
  {
    sourceProviders: ['wextractor', 'OAuth'],
    source: WextractorSource.GoogleMaps,
    icon: GoogleIcon,
    url: 'https://www.google.com',
    hasSourceSearch: true,
  },
  {
    sourceProviders: ['OAuth'],
    source: WextractorSource.Facebook,
    icon: FacebookIcon,
    url: 'https://www.facebook.com',
  },
  {
    sourceProviders: ['wextractor'],
    source: WextractorSource.G2,
    icon: G2Icon,
    url: 'https://www.g2.com',
  },
  {
    sourceProviders: ['wextractor'],
    source: WextractorSource.Capterra,
    icon: CapterraIcon,
    url: 'https://www.capterra.com',
  },
  {
    sourceProviders: ['wextractor'],
    source: WextractorSource.Tripadvisor,
    icon: TripadvisorIcon,
    url: 'https://www.tripadvisor.com',
  },
  {
    sourceProviders: ['wextractor'],
    source: WextractorSource.Yelp,
    icon: YelpIcon,
    url: 'https://www.yelp.com',
    isLanguageSpecific: true,
  },
  {
    sourceProviders: ['wextractor'],
    source: WextractorSource.GooglePlay,
    icon: GooglePlayIcon,
    url: 'https://play.google.com',
    isLanguageSpecific: true,
  },
]
